export const changeMapboxUrlLogo = () => {
    document.getElementsByClassName("mapboxgl-ctrl-logo")[0].href = "https://www.guidos.tours/";
}